





































    import AbpBase from "@/lib/abpbase"; 
    import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
    import util from '@/lib/util'
    import {
        GetSqlTempData,
    } from "@/api/systemBasic";
    import {
        BatchSaveAppoinment
    } from "@/api/follow/followUpAppointment";
    
    import editAppointment from "./edit.vue";
    @Component({components: { editAppointment }})
    export default class  extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        @Prop({type:Object,default:{}}) data:any;
        title="";
        patientName="";
        patients:any=[];
        patientAll:any=[];
        selectedTableRow: any[] = [];
        selectedTable2Row: any[] = [];
        addData: any[] = [];
        editShow = false ;
        editAppointmentData:any={};
        loading=false;
        patientColumn = [
            {
                type: "selection",
                width: 60,
                align: "center",
            },
            {
                title: "患者姓名",
                key: "PatientName",
            },
            {
                title: "身份证",
                key: "IdentityCard",
            }
        ];

        addColumn = [
        {
            type: "selection",
            width: 60,
            align: "center",
        },
        {
        title: "患者姓名",
        key: "PatientName",
        },
        {
            title: "身份证",
            key: "IdentityCard",
        },
        {
            title: "随访内容",
            key: "FollowUpContent",
        },
        {
            title: "备注",
            key: "Note",
        },
        {
        title: "操作",
        width: 180,
        render: (h1: any, params: any) => {
            const h = this.$createElement;
            let isdefaultDom: any;
            return h("div", [
                isdefaultDom,
                h(
                    "Button",
                    {
                    props: {
                        type: "primary",
                        size: "small",
                    },
                    style: {
                        marginRight: "15px",
                    },
                    on: {
                        click: () => {
                            this.editData(params.row,params.index);
                        },
                    },
                    },
                    "编辑"
                ),
                h(
                    "Button",
                    {
                    props: { type: "error", size: "small" },
                    on: {
                        click: () => {
                            this.delData(params.row,params.index);
                        },
                    },
                    },
                    "删除"
                ),
                ]);
            },
            },
        ];
        //表格高度
        get tableHeight() {
            return window.innerHeight - 200;
        }
        async created() 
        {
            this.title = this.data.Date +" 新增";
            this.getData();
        }
        async refreshData(){
            if(this.editAppointmentData.saveType=="批量新增"){
                let patientList = this.selectedTableRow.map((row) => {
                    return row;
                });
                patientList.forEach(item => {
                    this.addData.push({
                        PatientId:item.PatientId,
                        Date:this.editAppointmentData.Date,
                        FollowUpContent:this.editAppointmentData.FollowUpContent,
                        Note:this.editAppointmentData.Note,
                        PatientName:item.PatientName,
                        IdentityCard:item.IdentityCard,
                    })
                });
                this.screenPatient();
            }
            else{
                this.addData[this.editAppointmentData.index].Note = this.editAppointmentData.Note;
                this.addData[this.editAppointmentData.index].FollowUpContent = this.editAppointmentData.FollowUpContent;
            }
        }
        page = 1 //当前页
        tableTotalSize = 0
        pageChange(val:any){
		this.page = val
		this.getData()
	    }
        async getData(){
            this.selectedTableRow=[];
            this.selectedTable2Row=[];
            let res = await GetSqlTempData(this.getQuery());
            if (res.objects.jsonText && res.objects.jsonText.length > 0) {
                this.patientAll = JSON.parse(res.objects.jsonText);
                this.screenPatient();
            } else {
                this.patientAll = [];
            }
        }
        private getQuery() {
            var queryList=[];
            queryList.push({
                title: "PatientName",
                valueStr: this.patientName,
                id: 0,
                isLastSave: false,
                lastSaveValue: ""
            })
            queryList.push({
                title: "SelectDate",
                valueStr: this.data.Date,
                id: 0,
                isLastSave: false,
                lastSaveValue: ""
            })

            var queryJson = JSON.stringify(queryList);
            let query = {
                QueryJson: queryJson,
                SqlName: "随访预约记录日历-新增患者",
                page: this.page,
            };
            
            return query;
        }
        screenPatient(){
            this.selectedTableRow=[];
            this.selectedTable2Row=[];
            let idList = this.addData.map((row) => {
                return row.PatientId;
            });
            this.patients = this.patientAll.filter((x:any) => idList.indexOf(x.PatientId)==-1);
        }
        cancel() {
            this.$emit("input", false);
        }
        visibleChange(value: boolean) {
            if (!value) {
            this.$emit("input", value);
            }
        }
        batchAdd()
        {
            if(this.selectedTableRow.length<=0) {
                this.$Message.error("请勾选需要预约的患者！");
                return;
            }
            this.editAppointmentData = Object.assign({},this.data);
            this.editAppointmentData.saveType="批量新增";
            this.editShow = true;
        }
        editData(row:any,index:number){

            this.editAppointmentData = row;
            this.editAppointmentData.saveType="新增编辑";
            this.editAppointmentData.index = index;
            this.editShow = true;
        }
        async delData(row:any,index:number){
            this.$Modal.confirm({
            title: "提示",
            content: "此操作将永久删除该预约记录, 是否继续?",
            onOk: async () => {
                this.addData.splice(index, 1)
                this.screenPatient();
            },
            });
        }
        tableSelectionChange(selection: any) {
            this.selectedTableRow = selection;
        }
        tableSelectionChange2(selection: any) {
            this.selectedTable2Row = selection;
        }
        async batchDelete(){
             this.$Modal.confirm({
            title: "提示",
            content: "此操作将永久删除勾选的预约记录, 是否继续?",
            onOk: async () => {
                let idList = this.selectedTable2Row.map((row) => {
                    return row.PatientId;
                });
                this.addData = this.addData.filter((x) => idList.indexOf(x.PatientId)==-1);
                this.screenPatient();
             },
            });
        }
         async save(){
            this.loading=true;
            let data ={
                Date:this.data.Date,
                AddData:this.addData
            }
            let res = await BatchSaveAppoinment(data)
            if(res.status==1){
                this.$emit('input',false);
                this.$emit('on-success')
            }
            this.loading=false;
         }
    }



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/follow/followUpAppointment/add.vue